const sharedFields = ["id", "protocol", "location", "server_bundles", "provider", "is_enabled", "load_index", "metadata", "preshared_secret"];

const GRPCFields = ["ip", "port", "server_address", "capacity", "comment", "os"];
const OpenVPNFields = ["ip", "port", "server_address", "capacity", "secret", "comment", "os"];
const LocalDNSFields = ["comment", "ip", "server_address"];

const filterNodeBody = (body) => {
    let fieldsList;

    switch (body.protocol) {
        case "OpenVPN_UDP":
        case "OpenVPN_TCP":
        case "IKEv2":
            fieldsList = sharedFields.concat(OpenVPNFields);
            break;
        case "IKEv1":
            fieldsList = sharedFields.concat(OpenVPNFields);
            break;
        case "L2TPOverIPSEC":
            fieldsList = sharedFields.concat(OpenVPNFields);
            break;
        case "GRPC":
            fieldsList = sharedFields.concat(GRPCFields);
            break;

        case "LocalDNS":
        case "Hysteria2":
            body.server_address = "127.0.0.1";
        case "CustomDNSConfigurations":
            body.ip = "127.0.0.1";
            fieldsList = sharedFields.concat(LocalDNSFields);
            break;
    }

    return Object.fromEntries(
        Object.entries(body).filter(([key]) => fieldsList.includes(key))
    );
};

export default filterNodeBody;
